"use strict";
var Rect = (function () {
    function Rect(x, y, w, h) {
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
    }
    Rect.prototype.fitsIn = function (outer) {
        return outer.w >= this.w && outer.h >= this.h;
    };
    ;
    Rect.prototype.sameSizeAs = function (other) {
        return this.w === other.w && this.h === other.h;
    };
    ;
    return Rect;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Rect;
//# sourceMappingURL=Rect.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/texture-atlas/lib/Rect.js
 ** module id = 403
 ** module chunks = 0
 **/